import React, { useMemo, useState, useRef, useEffect, useCallback } from 'react';
import { Row, Col, Button } from 'tea-component';
import GamePillarItem from '@gp/pages/Pipeline/ProjectDetails/GameDetail/components/GamePillar/components/GamePillarItem';
import NoData from '@gp/components/NoData';
import SwiperFullModal from '@gp/components/SwiperFullModal';
import classnames from 'classnames';
import './index.scss';

const GamePillarList = (props: any) => {
  const { gamePillarDatas, getAdd, userIsAbleEdit, headTitle } = props;

  const [visibleImage, setVisibleImage] = useState(false);
  const [selectItem, setSelectItem] = useState<{ [keyName: string]: any }>({});

  // 最大高度子项高度
  const [maxHeight, setMaxHeight] = useState<number>(0);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  const imgListCur = useMemo(() => {
    return gamePillarDatas?.map((subItem: any) => subItem?.cover);
  }, [gamePillarDatas]);

  const isAllImgEmpty = useMemo(() => {
    return gamePillarDatas?.every((item: any) => item.cover === '');
  }, [gamePillarDatas]);

  const isAllIntroductionEmpty = useMemo(() => {
    return gamePillarDatas?.every((item: any) => item.introduction === '');
  }, [gamePillarDatas]);

  // 关闭图片预览
  const handleCloseImagePreview = () => {
    setVisibleImage(false);
  };

  // 打开图片预览
  const onClickImgHandle = () => {
    setVisibleImage(true);
  };

  // 计算所点击的图片是图片数组里的第几张
  const activeSwiperIdxCur = useMemo(() => {
    let indexValue = 0;
    gamePillarDatas?.forEach((item: any, index: number) => {
      if (selectItem.id === item.id) {
        indexValue = index;
      }
    });
    return indexValue;
  }, [selectItem, gamePillarDatas]);

  // 计算最大高度
  const calculateMaxHeight = useCallback(() => {
    setMaxHeight(0);
    const heights = itemRefs?.current?.map((ref) => {
      if (ref) {
        const textElement = ref.querySelector('.dbg-game-pillar-data-text') as HTMLElement;
        return textElement ? textElement.offsetHeight : 0;
      }
      return 0;
    });

    if (heights.length > 0) {
      const maxHeightValue = Math.max(...heights);
      setMaxHeight(maxHeightValue);
    }
  }, []);

  useEffect(() => {
    calculateMaxHeight();

    // 监听窗口变化
    const handleResize = () => {
      calculateMaxHeight();
    };

    // 监听每个GamePillarItem的尺寸变化
    resizeObserverRef.current = new ResizeObserver(handleResize);

    itemRefs.current.forEach((ref) => {
      if (ref) {
        resizeObserverRef.current?.observe(ref);
      }
    });

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      resizeObserverRef.current?.disconnect();
    };
  }, [gamePillarDatas, calculateMaxHeight]);

  // 更新ref数组
  const updateItemRef = (index: number) => (ref: HTMLDivElement | null) => {
    itemRefs.current[index] = ref;
  };

  return (
    <>
      {gamePillarDatas?.length ? (
        <>
          <Row
            className={classnames('dbg-game-pillar-data-row', {
              three: gamePillarDatas?.length === 3,
              four: gamePillarDatas?.length === 4,
              five: gamePillarDatas?.length === 5,
              'dbg-game-pillar-data-row-empty-img': isAllImgEmpty,
              'dbg-game-pillar-data-row-empty-introduction': isAllIntroductionEmpty,
              'dbg-game-pillar-data-row-empty-img-has-des': isAllImgEmpty && !isAllIntroductionEmpty,
            })}
          >
            {gamePillarDatas?.map((item: any, index: any) => {
              return (
                <Col
                  key={index}
                  className="dbg-game-pillar-data-row-col"
                  onClick={() => {
                    setSelectItem(item);
                  }}
                >
                  <GamePillarItem
                    ref={updateItemRef(index)}
                    gamePillar={item}
                    onClickImgHandle={onClickImgHandle}
                    setSelectItem={setSelectItem}
                    maxHeight={maxHeight}
                  />
                </Col>
              );
            })}
          </Row>
        </>
      ) : (
        <NoData
          className="dbg-project-detail__body-game-pillar-nodata"
          text={
            userIsAbleEdit ? (
              <>
                Please click the Edit button on the right or directly{' '}
                <Button
                  type="link"
                  onClick={() => {
                    getAdd();
                  }}
                >
                  add Game Pillar.
                </Button>
              </>
            ) : (
              <>No Data</>
            )
          }
          height={170}
        />
      )}
      {visibleImage && (
        <SwiperFullModal
          visible={visibleImage}
          imageList={imgListCur}
          activeSwiperIdxCur={activeSwiperIdxCur}
          onClose={handleCloseImagePreview}
          headTitle={headTitle}
        />
      )}
    </>
  );
};

export default GamePillarList;
